import React from 'react';

export const FormattedDuration: React.FC<{ seconds: number }> = ({ seconds: remainingSeconds }) => {
    const numberOfHours = Math.floor(remainingSeconds / 60 / 60);
    const hours = numberOfHours.toFixed(0);
    remainingSeconds = remainingSeconds % (60 * 60);
    const numberOfMinutes = Math.floor(remainingSeconds / 60);
    const minutes = numberOfMinutes.toFixed(0).padStart(2, '0');
    const seconds = (remainingSeconds % 60).toFixed(0).padStart(2, '0');

    if (numberOfHours === 0) {
        return <>{`${minutes}:${seconds}`}</>;
    }

    return <>{`${hours}:${minutes}:${seconds}`}</>;
};
